import { Model } from '@vuex-orm/core'
import Vue from 'vue'
import { defaultDate } from '../utils/helper'

export default class NewspaperModel extends Model {
  static entity = 'newspaper'

  static state () {
    return {
      isShowModal: false,
      modalText: '',
      page: 'login'
    }
  }

  static fields () {
    return {
      id: this.number(1),
      background: this.boolean(false),
      isLarge: this.boolean(false), // for large font mode
      date: this.string(''),
      logo: this.string(''),
      issuer: this.string(''),
      image_caption: this.string(''),
      image_url: this.string(''),
      lead_sentence: this.string(''),
      article_title: this.string(''),
      headline: this.string(''),
      sleeve_title: this.string(''),
      content: this.attr(null),
      svg: this.attr(null)
    }
  }

  /**
   * set default
   * @type {{date: string, article_title: string, sleeve_title: string, image_url: string, image_alt: string, logo: string, id: number, lead_sentence: string, headline: string, issuer: string}}
   */
  static defaultValue = {
    id: 1,
    background: false,
    isLarge: this.boolean(false), // for large font mode
    date: defaultDate(),
    logo: '',
    issuer: '',
    image_alt: '',
    image_url: '',
    lead_sentence: '',
    article_title: '',
    headline: '',
    sleeve_title: '',
    content: ''
  }
}